import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
@Injectable({
  providedIn: 'root',
})
export class StorageService {
  [x: string]: any;
  set(key: string, value: string): Promise<void> {
    return new Promise<void>(async resolve => {
      await Preferences.set({ key: key, value: value });
      resolve();
    });
  }
  get(key: string): Promise<string> {
    return new Promise<string>(async resolve => {
      const { value } = await Preferences.get({ key: key });
      return resolve(value as string);
    });
  }
  remove(key: string): Promise<void> {
    return new Promise<void>(async resolve => {
      await Preferences.remove({ key: key });
      resolve();
    });
  }
  clear(): Promise<void> {
    return new Promise<void>(async resolve => {
      await Preferences.clear();
      return resolve();
    });
  }
  keys(): Promise<string[]> {
    return new Promise<string[]>(async resolve => {
      const { keys } = await Preferences.keys();
      resolve(keys || []);
    });
  }
}
